import { render, staticRenderFns } from "./DContentPreview.vue?vue&type=template&id=00230744&"
import script from "./DContentPreview.vue?vue&type=script&lang=js&"
export * from "./DContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./DContentPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports